import type { ReactNode } from "react";

export type OptionValue = string | number;

export interface SelectOption {
  value: OptionValue;
  label?: ReactNode;
  caption?: ReactNode;
  disabled?: boolean;
}

export const getErrorMessage = (error: unknown): string => {
  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string"
  ) {
    return error.message;
  }

  return "";
};
